// src/contexts/BlogContext.jsx
import { createContext, useState, useEffect, useContext } from 'react';
import { get } from '../utils/api';
import { getUserLanguage } from '../utils/language';

export const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const language = getUserLanguage();

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const headers = { 'accept-language': language };
        
        // Fetch latest posts (limited to 5)
        const postsData = await get('/blog?limit=5', headers);
        setPosts(postsData.posts || []);
        
        // Fetch categories
        const categoriesData = await get('/blog/categories/list', headers);
        setCategories(categoriesData || []);
        
        // Fetch tags
        const tagsData = await get('/blog/tags/list', headers);
        setTags(tagsData || []);
        
        setError(null);
      } catch (error) {
        console.error('[BlogContext] Error fetching blog data:', error);
        setError(language === 'cs' ? 'Nepodařilo se načíst data blogu' : 'Failed to load blog data');
      } finally {
        setLoading(false);
      }
    };
    
    fetchBlogData();
  }, [language]);

  return (
    <BlogContext.Provider value={{ 
      posts, 
      categories, 
      tags, 
      loading, 
      error 
    }}>
      {children}
    </BlogContext.Provider>
  );
};

export const useBlog = () => {
  const context = useContext(BlogContext);
  if (!context) {
    throw new Error('useBlog must be used within a BlogProvider');
  }
  return context;
};